import React, { useRef } from "react";

// A technical card with a radial green glow following the cursor.
export function TechCard({ children, className = "", ...rest }) {
    const ref = useRef(null);
    const onMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        el.style.setProperty("--mx", `${e.clientX - r.left}px`);
        el.style.setProperty("--my", `${e.clientY - r.top}px`);
    };
    return (
        <div ref={ref} onMouseMove={onMove} className={`tech-card p-8 ${className}`} {...rest}>
            {children}
        </div>
    );
}
